var map = {
	"./ic-action-edit-line.png": 26344,
	"./ic-action-edit-line.svg": 77106,
	"./ic-action-edit.png": 36055,
	"./ic-action-edit.svg": 15195,
	"./ic-action-points-detail.png": 82750,
	"./ic-action-points-detail.svg": 72880,
	"./ic-action-reward-redemption-history.png": 99377,
	"./ic-action-reward-redemption-history.svg": 58203,
	"./ic-action-sales-history.png": 2104,
	"./ic-action-sales-history.svg": 4050,
	"./ic-add-outline.png": 18340,
	"./ic-add-outline.svg": 29556,
	"./ic-air-ducting.png": 94507,
	"./ic-air-ducting.svg": 82483,
	"./ic-approve.png": 30751,
	"./ic-approve.svg": 98235,
	"./ic-arrow-accordion-close.png": 23609,
	"./ic-arrow-accordion-close.svg": 16757,
	"./ic-arrow-accordion-open.png": 75021,
	"./ic-arrow-accordion-open.svg": 5903,
	"./ic-arrow-accordion-outline-close.png": 42752,
	"./ic-arrow-accordion-outline-close.svg": 66288,
	"./ic-arrow-accordion-outline-open.png": 91078,
	"./ic-arrow-accordion-outline-open.svg": 32844,
	"./ic-arrow-back-blue.png": 79398,
	"./ic-arrow-back-blue.svg": 44274,
	"./ic-arrow-back.png": 85455,
	"./ic-arrow-back.svg": 71365,
	"./ic-arrow-calendar-next.png": 21924,
	"./ic-arrow-calendar-next.svg": 21456,
	"./ic-arrow-calendar-prev.png": 86848,
	"./ic-arrow-calendar-prev.svg": 71672,
	"./ic-arrow-carousel-next-blue.png": 40743,
	"./ic-arrow-carousel-next-blue.svg": 75957,
	"./ic-arrow-carousel-next-green.png": 75794,
	"./ic-arrow-carousel-next-green.svg": 52334,
	"./ic-arrow-carousel-next.png": 97356,
	"./ic-arrow-carousel-next.svg": 51916,
	"./ic-arrow-carousel-prev-blue.png": 80027,
	"./ic-arrow-carousel-prev-blue.svg": 22613,
	"./ic-arrow-carousel-prev.png": 52552,
	"./ic-arrow-carousel-prev.svg": 91596,
	"./ic-arrow-chevron-next-blue.png": 78174,
	"./ic-arrow-chevron-next-blue.svg": 30166,
	"./ic-arrow-dropdown-user.png": 34293,
	"./ic-arrow-dropdown-user.svg": 28125,
	"./ic-arrow-goto-page-white.png": 59959,
	"./ic-arrow-goto-page-white.svg": 61511,
	"./ic-arrow-goto-page.png": 19991,
	"./ic-arrow-goto-page.svg": 96583,
	"./ic-arrow-goto.png": 89819,
	"./ic-arrow-goto.svg": 49757,
	"./ic-arrow-notification.png": 48455,
	"./ic-arrow-notification.svg": 19009,
	"./ic-arrow-select.png": 97482,
	"./ic-arrow-select.svg": 32996,
	"./ic-arrow-sidemenu.png": 8182,
	"./ic-arrow-sidemenu.svg": 74504,
	"./ic-arrow-sort-ascending.png": 38999,
	"./ic-arrow-sort-ascending.svg": 23105,
	"./ic-arrow-sort-descending.png": 32675,
	"./ic-arrow-sort-descending.svg": 28187,
	"./ic-arrow-stat-down.png": 60779,
	"./ic-arrow-stat-down.svg": 49715,
	"./ic-arrow-stat-up.png": 31816,
	"./ic-arrow-stat-up.svg": 61644,
	"./ic-arrow-tail-subsegment.png": 36774,
	"./ic-arrow-tail-subsegment.svg": 46542,
	"./ic-arrow-viewmore-close.png": 38501,
	"./ic-arrow-viewmore-close.svg": 61383,
	"./ic-arrow-viewmore-open.png": 74753,
	"./ic-arrow-viewmore-open.svg": 3705,
	"./ic-bar-chart-blue.png": 10403,
	"./ic-bar-chart-blue.svg": 33841,
	"./ic-bar-chart-brown.png": 77891,
	"./ic-bar-chart-brown.svg": 5635,
	"./ic-bar-chart-green.png": 6494,
	"./ic-bar-chart-green.svg": 7498,
	"./ic-bar-chart-orange.png": 18265,
	"./ic-bar-chart-orange.svg": 47447,
	"./ic-bar-chart-purple.png": 89641,
	"./ic-bar-chart-purple.svg": 90359,
	"./ic-bar-chart-yellow.png": 11599,
	"./ic-bar-chart-yellow.svg": 86865,
	"./ic-barcode-reader-blue.png": 1141,
	"./ic-barcode-reader-blue.svg": 67117,
	"./ic-barcode-reader-circle.png": 14245,
	"./ic-barcode-reader-circle.svg": 11489,
	"./ic-barcode-reader.png": 86402,
	"./ic-barcode-reader.svg": 51764,
	"./ic-blank-customer.png": 79085,
	"./ic-blank-customer.svg": 43175,
	"./ic-blank-product.png": 19728,
	"./ic-blank-product.svg": 51696,
	"./ic-blank-reference.png": 14462,
	"./ic-blank-reference.svg": 98138,
	"./ic-broadcast.png": 63985,
	"./ic-broadcast.svg": 67081,
	"./ic-calendar-filter.png": 63957,
	"./ic-calendar-filter.svg": 3313,
	"./ic-calendar.png": 1796,
	"./ic-calendar.svg": 60562,
	"./ic-certificate-checked.png": 64685,
	"./ic-certificate-checked.svg": 88653,
	"./ic-certificate-gray.png": 95137,
	"./ic-certificate-gray.svg": 91343,
	"./ic-certificate-white.png": 26285,
	"./ic-certificate-white.svg": 50457,
	"./ic-certificate.png": 86993,
	"./ic-certificate.svg": 47589,
	"./ic-check-language.png": 34097,
	"./ic-check-language.svg": 99115,
	"./ic-checkbox-blue.png": 34520,
	"./ic-checkbox-blue.svg": 97080,
	"./ic-checkbox-circle-white.png": 88500,
	"./ic-checkbox-circle-white.svg": 52104,
	"./ic-checkbox-white.png": 46349,
	"./ic-checkbox-white.svg": 73179,
	"./ic-checkbox.png": 27409,
	"./ic-checkbox.svg": 89259,
	"./ic-checkin-circle.png": 46160,
	"./ic-checkin-circle.svg": 69714,
	"./ic-circle-blue.png": 62417,
	"./ic-circle-blue.svg": 87069,
	"./ic-circle-white-plus.png": 38361,
	"./ic-circle-white-plus.svg": 70653,
	"./ic-close-white.png": 65420,
	"./ic-close-white.svg": 60548,
	"./ic-coil-gray.png": 32107,
	"./ic-coil-gray.svg": 24031,
	"./ic-coil-lightblue.png": 64308,
	"./ic-coil-lightblue.svg": 27854,
	"./ic-coil-overlay.png": 90000,
	"./ic-coil-overlay.svg": 56162,
	"./ic-contact.png": 60168,
	"./ic-contact.svg": 67580,
	"./ic-cool-room-panel.png": 56404,
	"./ic-cool-room-panel.svg": 35812,
	"./ic-create-blue.png": 95609,
	"./ic-create-blue.svg": 509,
	"./ic-create.png": 36254,
	"./ic-create.svg": 77828,
	"./ic-customers.png": 61283,
	"./ic-customers.svg": 48715,
	"./ic-decking.png": 41801,
	"./ic-decking.svg": 24837,
	"./ic-delete-blue.png": 50494,
	"./ic-delete-blue.svg": 73934,
	"./ic-delete-outline.png": 76542,
	"./ic-delete-outline.svg": 6844,
	"./ic-delete.png": 69079,
	"./ic-delete.svg": 68793,
	"./ic-detail.png": 29233,
	"./ic-detail.svg": 49979,
	"./ic-discount-voucher-white.png": 42314,
	"./ic-discount-voucher-white.svg": 27596,
	"./ic-doc-no-data.png": 45279,
	"./ic-doc-no-data.svg": 14371,
	"./ic-doc-white.png": 42454,
	"./ic-doc-white.svg": 6886,
	"./ic-document-blue-view.png": 66928,
	"./ic-document-blue-view.svg": 28142,
	"./ic-document-blue.png": 93044,
	"./ic-document-blue.svg": 6848,
	"./ic-document-fill-blue.png": 59506,
	"./ic-document-fill-blue.svg": 84852,
	"./ic-document-fill.png": 47859,
	"./ic-document-fill.svg": 2639,
	"./ic-document-gray.png": 58493,
	"./ic-document-gray.svg": 57729,
	"./ic-document-history-blue.png": 42953,
	"./ic-document-history-blue.svg": 39525,
	"./ic-document-outline-blue.png": 42463,
	"./ic-document-outline-blue.svg": 70407,
	"./ic-document-template-white.png": 42630,
	"./ic-document-template-white.svg": 60830,
	"./ic-document-template.png": 43010,
	"./ic-document.png": 54709,
	"./ic-document.svg": 13283,
	"./ic-documents-blue.png": 5661,
	"./ic-documents-blue.svg": 6227,
	"./ic-documents-gray.png": 50499,
	"./ic-documents-gray.svg": 80002,
	"./ic-dowload-circle-outline-blue.png": 23619,
	"./ic-dowload-circle-outline-blue.svg": 95231,
	"./ic-download-circle-blue.png": 75108,
	"./ic-download-circle-blue.svg": 54426,
	"./ic-download-circle.png": 1061,
	"./ic-download-circle.svg": 73693,
	"./ic-download-template.png": 60039,
	"./ic-download-template.svg": 74495,
	"./ic-download.png": 83106,
	"./ic-download.svg": 70064,
	"./ic-edit-white.png": 4446,
	"./ic-edit-white.svg": 44740,
	"./ic-edit.png": 99242,
	"./ic-edit.svg": 64100,
	"./ic-error-info.png": 97225,
	"./ic-error-info.svg": 28867,
	"./ic-error-note.png": 56413,
	"./ic-error-note.svg": 71203,
	"./ic-export.png": 32556,
	"./ic-export.svg": 68674,
	"./ic-eye-gray.png": 16719,
	"./ic-eye-gray.svg": 84421,
	"./ic-eye-password-close-gray.png": 55348,
	"./ic-eye-password-close-gray.svg": 85692,
	"./ic-eye-password-gray.png": 29201,
	"./ic-eye-password-gray.svg": 35273,
	"./ic-fail.png": 4378,
	"./ic-fail.svg": 29796,
	"./ic-file-doc.png": 45757,
	"./ic-file-doc.svg": 69507,
	"./ic-file-docx.png": 7153,
	"./ic-file-docx.svg": 41793,
	"./ic-file-gif.png": 48997,
	"./ic-file-gif.svg": 68479,
	"./ic-file-jpeg.png": 38573,
	"./ic-file-jpeg.svg": 88013,
	"./ic-file-jpg.png": 14386,
	"./ic-file-jpg.svg": 56892,
	"./ic-file-pdf.png": 98765,
	"./ic-file-pdf.svg": 5075,
	"./ic-file-png.png": 72898,
	"./ic-file-png.svg": 94832,
	"./ic-file-ptt.png": 4479,
	"./ic-file-ptt.svg": 22321,
	"./ic-file-pttx.png": 19735,
	"./ic-file-pttx.svg": 82987,
	"./ic-file-xls.png": 49376,
	"./ic-file-xls.svg": 14542,
	"./ic-file-xlsx.png": 85290,
	"./ic-file-xlsx.svg": 22586,
	"./ic-flag-id.jpg": 42836,
	"./ic-flag-la.jpg": 76350,
	"./ic-flag-language-en.png": 51609,
	"./ic-flag-language-in.png": 42733,
	"./ic-flag-language-la.png": 40061,
	"./ic-flag-language-my.png": 43630,
	"./ic-flag-language-th.png": 26516,
	"./ic-flag-language-vt.png": 51938,
	"./ic-flag-my.jpg": 66177,
	"./ic-flag-th.jpg": 88107,
	"./ic-flag-vn.jpg": 41091,
	"./ic-flag-za.png": 77328,
	"./ic-grid.png": 30770,
	"./ic-grid.svg": 48400,
	"./ic-hamberger-menu.png": 8481,
	"./ic-hamberger-menu.svg": 91563,
	"./ic-home.png": 95687,
	"./ic-home.svg": 30917,
	"./ic-image-gray-2.png": 80158,
	"./ic-image-gray-2.svg": 88956,
	"./ic-image-gray.png": 82131,
	"./ic-image-gray.svg": 99261,
	"./ic-image.png": 66783,
	"./ic-image.svg": 23223,
	"./ic-info-error.png": 9663,
	"./ic-info-error.svg": 98761,
	"./ic-inventory.png": 59600,
	"./ic-inventory.svg": 24484,
	"./ic-isometric-square-white.png": 74627,
	"./ic-isometric-square-white.svg": 11733,
	"./ic-label-news.png": 9488,
	"./ic-label-news.svg": 28110,
	"./ic-label-promotions.png": 56215,
	"./ic-label-promotions.svg": 5277,
	"./ic-left-blue.png": 77520,
	"./ic-left-blue.svg": 40392,
	"./ic-lines.png": 82541,
	"./ic-lines.svg": 297,
	"./ic-list.png": 21190,
	"./ic-list.svg": 57864,
	"./ic-lists-gray.png": 69315,
	"./ic-lists-gray.svg": 11593,
	"./ic-location-blue.png": 24666,
	"./ic-location-blue.svg": 65954,
	"./ic-lock.png": 12499,
	"./ic-lock.svg": 80213,
	"./ic-logout.png": 14792,
	"./ic-logout.svg": 63314,
	"./ic-medal-bronze.png": 83048,
	"./ic-medal-bronze.svg": 50330,
	"./ic-medal-coin-bronze.png": 9434,
	"./ic-medal-coin-gold.png": 60400,
	"./ic-medal-coin-silver.png": 93237,
	"./ic-medal-gold.png": 29578,
	"./ic-medal-gold.svg": 34160,
	"./ic-medal-silver.png": 63547,
	"./ic-medal-silver.svg": 91557,
	"./ic-menu-pre-sales-transaction-white.png": 22539,
	"./ic-menu-pre-sales-transaction-white.svg": 35813,
	"./ic-menu-segment-blue.png": 76634,
	"./ic-menu-segment-blue.svg": 17410,
	"./ic-menu-warranty-gray.png": 90124,
	"./ic-menu-warranty-gray.svg": 76722,
	"./ic-minus-circle-slim-red.png": 67643,
	"./ic-minus-circle-slim-red.svg": 30951,
	"./ic-minus-white.png": 8236,
	"./ic-minus-white.svg": 25160,
	"./ic-more-lines.png": 36271,
	"./ic-more-lines.svg": 43421,
	"./ic-multiple-document.png": 16486,
	"./ic-multiple-document.svg": 8362,
	"./ic-non-residential.png": 58384,
	"./ic-notification-active.png": 37632,
	"./ic-notification-active.svg": 77472,
	"./ic-notification-barcode.png": 55532,
	"./ic-notification-barcode.svg": 70618,
	"./ic-notification-error-white.png": 70586,
	"./ic-notification-error-white.svg": 15184,
	"./ic-notification-error.png": 88534,
	"./ic-notification-error.svg": 94112,
	"./ic-notification-info-white.png": 47974,
	"./ic-notification-info-white.svg": 77774,
	"./ic-notification-info.png": 21186,
	"./ic-notification-info.svg": 47202,
	"./ic-notification-menu-white.png": 42235,
	"./ic-notification-menu-white.svg": 65763,
	"./ic-notification-order-inquiry.png": 42404,
	"./ic-notification-order-inquiry.svg": 59238,
	"./ic-notification-success-white.png": 43225,
	"./ic-notification-success-white.svg": 61227,
	"./ic-notification-success.png": 47645,
	"./ic-notification-success.svg": 57275,
	"./ic-notification.png": 47075,
	"./ic-notification.svg": 10989,
	"./ic-open-document-gray.png": 2596,
	"./ic-open-document-gray.svg": 6006,
	"./ic-order-inquiry.png": 97108,
	"./ic-order-inquiry.svg": 87220,
	"./ic-page-customer.png": 54822,
	"./ic-page-customer.svg": 95214,
	"./ic-page-documents.png": 83686,
	"./ic-page-documents.svg": 98612,
	"./ic-page-home.png": 14587,
	"./ic-page-home.svg": 36967,
	"./ic-page-inventory.png": 95124,
	"./ic-page-inventory.svg": 71874,
	"./ic-page-notification-management.png": 99331,
	"./ic-page-notification-management.svg": 90061,
	"./ic-page-order-inquiry.png": 35464,
	"./ic-page-order-inquiry.svg": 93386,
	"./ic-page-report.png": 868,
	"./ic-page-report.svg": 31112,
	"./ic-page-rewards.png": 33716,
	"./ic-page-rewards.svg": 53542,
	"./ic-page-sales-transaction.png": 66967,
	"./ic-page-sales-transaction.svg": 49213,
	"./ic-page-settings.png": 52769,
	"./ic-page-settings.svg": 32517,
	"./ic-page-upload-transaction.png": 29478,
	"./ic-page-upload-transaction.svg": 6630,
	"./ic-page-warranty.png": 8650,
	"./ic-page-warranty.svg": 53350,
	"./ic-page-year-warranty.png": 6016,
	"./ic-page-year-warranty.svg": 87010,
	"./ic-phone-ref-code-blue.png": 75159,
	"./ic-phone-ref-code-blue.svg": 11639,
	"./ic-photo.png": 5936,
	"./ic-photo.svg": 11428,
	"./ic-placeholder-avatar.png": 69421,
	"./ic-placeholder-avatar.svg": 40731,
	"./ic-placeholder-image.png": 54339,
	"./ic-placeholder-image.svg": 36943,
	"./ic-placeholder-segment.png": 49823,
	"./ic-placeholder-segment.svg": 28883,
	"./ic-plus-circle-disabled.png": 45236,
	"./ic-plus-circle-disabled.svg": 54410,
	"./ic-plus-circle-slim-blue.png": 37926,
	"./ic-plus-circle-slim-blue.svg": 75570,
	"./ic-plus-white.png": 38774,
	"./ic-plus-white.svg": 6352,
	"./ic-point.png": 49862,
	"./ic-point.svg": 44146,
	"./ic-pre-sales-transaction.png": 55443,
	"./ic-pre-sales-transaction.svg": 73439,
	"./ic-pre-transaction-blue.png": 81211,
	"./ic-pre-transaction-blue.svg": 7917,
	"./ic-pre-transaction.png": 37032,
	"./ic-pre-transaction.svg": 2292,
	"./ic-print.png": 36241,
	"./ic-print.svg": 80661,
	"./ic-printer.png": 98056,
	"./ic-printer.svg": 49180,
	"./ic-purlin-girt.png": 36793,
	"./ic-purlin-girt.svg": 73361,
	"./ic-radio-checked.png": 59265,
	"./ic-radio-checked.svg": 18089,
	"./ic-redeem.png": 68690,
	"./ic-redeem.svg": 15564,
	"./ic-ref-code-blue.png": 11200,
	"./ic-ref-code-blue.svg": 95012,
	"./ic-reference-circle.png": 25746,
	"./ic-reference-circle.svg": 4884,
	"./ic-reference-lightblue.png": 21404,
	"./ic-reference-lightblue.svg": 83592,
	"./ic-reference-white.png": 57935,
	"./ic-reference-white.svg": 10615,
	"./ic-reference.png": 81727,
	"./ic-reference.svg": 44279,
	"./ic-refresh.png": 65365,
	"./ic-regenerate-file.png": 59021,
	"./ic-regenerate-file.svg": 40053,
	"./ic-report.png": 29280,
	"./ic-report.svg": 87158,
	"./ic-residential.png": 4854,
	"./ic-rewards.png": 51192,
	"./ic-rewards.svg": 36332,
	"./ic-roof.png": 52792,
	"./ic-roof.svg": 65802,
	"./ic-sale-order-white.png": 79620,
	"./ic-sale-order-white.svg": 61042,
	"./ic-sale-order.png": 10020,
	"./ic-sale-order.svg": 84566,
	"./ic-sales-transaction.png": 28243,
	"./ic-sales-transaction.svg": 15755,
	"./ic-search-dark.png": 34077,
	"./ic-search-dark.svg": 74625,
	"./ic-search.png": 41190,
	"./ic-search.svg": 29244,
	"./ic-select-customer.png": 90713,
	"./ic-select-customer.svg": 25305,
	"./ic-selected-active.png": 33778,
	"./ic-selected-active.svg": 50362,
	"./ic-selected-inactive.png": 66359,
	"./ic-selected-inactive.svg": 88167,
	"./ic-settings.png": 29165,
	"./ic-settings.svg": 59783,
	"./ic-share-blue-circle.png": 70763,
	"./ic-share-blue-circle.svg": 58779,
	"./ic-share.png": 9321,
	"./ic-share.svg": 66505,
	"./ic-shutter-ex.png": 38381,
	"./ic-shutter-ex.svg": 89127,
	"./ic-status-checked-blue.png": 50447,
	"./ic-status-checked-blue.svg": 42579,
	"./ic-status-checked.png": 64740,
	"./ic-status-checked.svg": 87818,
	"./ic-status-default.png": 81448,
	"./ic-status-default.svg": 94066,
	"./ic-status-fail.png": 80835,
	"./ic-status-fail.svg": 98335,
	"./ic-status-success.png": 41446,
	"./ic-status-success.svg": 83384,
	"./ic-success.png": 5549,
	"./ic-success.svg": 4385,
	"./ic-symbol-trained.png": 80860,
	"./ic-symbol-trained.svg": 43494,
	"./ic-table-blue.png": 62523,
	"./ic-table-blue.svg": 12797,
	"./ic-transaction.png": 36584,
	"./ic-transaction.svg": 87864,
	"./ic-trash-red.png": 97568,
	"./ic-trash-red.svg": 15132,
	"./ic-truss-frame.png": 83801,
	"./ic-truss-frame.svg": 12609,
	"./ic-unit-minus.png": 1067,
	"./ic-unit-minus.svg": 56529,
	"./ic-unit-plus.png": 82963,
	"./ic-unit-plus.svg": 67699,
	"./ic-updated.png": 17633,
	"./ic-updated.svg": 88109,
	"./ic-upload.png": 47269,
	"./ic-upload.svg": 89227,
	"./ic-validate-file.png": 54389,
	"./ic-validate-file.svg": 42325,
	"./ic-verify-phone-blue.png": 9977,
	"./ic-verify-phone-blue.svg": 29205,
	"./ic-verify-question-blue.png": 7471,
	"./ic-verify-question-blue.svg": 73461,
	"./ic-wall-vertical.png": 43019,
	"./ic-wall-vertical.svg": 28823,
	"./ic-wall.png": 72882,
	"./ic-wall.svg": 8436,
	"./ic-warranty-category-project.png": 60605,
	"./ic-warranty-category-residential.png": 42616,
	"./ic-warranty-generate-white.png": 68984,
	"./ic-warranty-generate-white.svg": 3832,
	"./ic-warranty-generate.png": 27032,
	"./ic-warranty-generate.svg": 69688,
	"./ic-warranty-gray.png": 49588,
	"./ic-warranty-gray.svg": 69852,
	"./ic-warranty-guideline-white.png": 16663,
	"./ic-warranty-guideline-white.svg": 76561,
	"./ic-warranty-guideline.png": 2391,
	"./ic-warranty-guideline.svg": 87469,
	"./ic-warranty-template-white.png": 36763,
	"./ic-warranty-template-white.svg": 2567,
	"./ic-warranty-template.png": 55179,
	"./ic-warranty-template.svg": 99751,
	"./ic-warranty.png": 36214,
	"./ic-warranty.svg": 92152,
	"./ic-website.png": 30295,
	"./ic-website.svg": 46591
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13717;